var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 960.0 720.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l960.0 0l0 720.0l-960.0 0l0 -720.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l960.0 0l0 720.0l-960.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m147.85728 488.83978c-66.63359 -157.30255 -3.002533 -337.58588 149.6551 -424.0119c152.65762 -86.425995 348.41626 -52.994194 460.40845 78.6289c111.99219 131.62311 106.526184 321.83994 -12.855591 447.37463c-119.381836 125.53467 -316.76453 148.62134 -464.2282 54.297913l199.16296 -285.12933z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m147.85728 488.83978c-66.63359 -157.30255 -3.002533 -337.58588 149.6551 -424.0119c152.65762 -86.425995 348.41626 -52.994194 460.40845 78.6289c111.99219 131.62311 106.526184 321.83994 -12.855591 447.37463c-119.381836 125.53467 -316.76453 148.62134 -464.2282 54.297913",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeDasharray: "72.0,96.0,0.0,96.0",
    d: "m147.85728 488.83978c-66.63359 -157.30255 -3.002533 -337.58588 149.6551 -424.0119c152.65762 -86.425995 348.41626 -52.994194 460.40845 78.6289c111.99219 131.62311 106.526184 321.83994 -12.855591 447.37463c-119.381836 125.53467 -316.76453 148.62134 -464.2282 54.297913",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m222.15318 202.71536l100.12224 0l65.290344 300.9108l243.7634 0l41.35315 -229.5799l-332.99692 2.224121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "bevel",
    strokeLinecap: "round",
    d: "m222.15318 202.71536l100.12224 0l65.290344 300.9108l243.7634 0l41.35315 -229.5799l-332.99692 2.224121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m387.08813 573.6233l0 0c0 -18.316711 14.848663 -33.165344 33.165375 -33.165344l0 0c8.79599 0 17.23172 3.4942017 23.451447 9.713928c6.219696 6.2196655 9.713898 14.6553955 9.713898 23.451416l0 0c0 18.316711 -14.848633 33.165344 -33.165344 33.165344l0 0c-18.316711 0 -33.165375 -14.848633 -33.165375 -33.165344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m387.08813 573.6233l0 0c0 -18.316711 14.848663 -33.165344 33.165375 -33.165344l0 0c8.79599 0 17.23172 3.4942017 23.451447 9.713928c6.219696 6.2196655 9.713898 14.6553955 9.713898 23.451416l0 0c0 18.316711 -14.848633 33.165344 -33.165344 33.165344l0 0c-18.316711 0 -33.165375 -14.848633 -33.165375 -33.165344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m559.72614 573.6233l0 0c0 -18.316711 14.848633 -33.165344 33.165344 -33.165344l0 0c8.795959 0 17.23175 3.4942017 23.451416 9.713928c6.2197266 6.2196655 9.713928 14.6553955 9.713928 23.451416l0 0c0 18.316711 -14.848633 33.165344 -33.165344 33.165344l0 0c-18.316711 0 -33.165344 -14.848633 -33.165344 -33.165344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m559.72614 573.6233l0 0c0 -18.316711 14.848633 -33.165344 33.165344 -33.165344l0 0c8.795959 0 17.23175 3.4942017 23.451416 9.713928c6.2197266 6.2196655 9.713928 14.6553955 9.713928 23.451416l0 0c0 18.316711 -14.848633 33.165344 -33.165344 33.165344l0 0c-18.316711 0 -33.165344 -14.848633 -33.165344 -33.165344z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIShop);
export default __webpack_public_path__ + "static/media/IShop.2edc295499e4a3ca6c878d9860544980.svg";
export { ForwardRef as ReactComponent };